import { observable, action } from "mobx";
import agent from "../agent";
import userStore from "./userStore";
import profileStore from "./profileStore";
import templateStore from "./templateStore";
import generalProfileStore from "./generalProfileStore";
import { Promise } from "bluebird";
import { ProfileType } from "../types/enum";
import validate from "../helper/validation.js"
import moment from "moment"
class AgentVenueContactStore {
    @observable id = undefined
    @observable venueLegalEntityName = ""
    @observable venueEmail= ""
    @observable venuePhone = ""
    @observable streetAddress= ""
    @observable suburb= ""
    @observable postCode= ""
    @observable state= "" 
    @observable country= ""
    @observable venueContactName = ""
    @observable  manageContactName= ""
    @observable  manageContactEmail= ""
    @observable  manageContactPhone= ""
    @observable switchOn = false


    @action
    setSwitchOn(){
        this.switchOn = !this.switchOn
    }
    @action
    setVenuePhone(value){
        this.venuePhone = value
    }
    @action
    setContactPhone(value){
        this.manageContactPhone = value
    }
    @action
    setContactName(value){
        this.manageContactName = value
    } 
    @action
    setContactEmail(value){
        this.manageContactEmail = value
    }
    
    @action
    setVenueLegalEntityName(value){
        this.venueLegalEntityName = value
    }

    @action
    setPostCode(value){
        this.postCode = value
    }
    @action
    setVenueEmail(value){
        this.venueEmail = value
    }
  
    @action
    setstreetAddress(value){
        this.streetAddress = value
    }
    @action
    setsuburb(value){
        this.suburb = value
    }
    @action
    setPostalOutgoing(value){
        this.postalOutgoing = value
        
    }
    @action
    setstate(value){
        this.state = value
    }
    @action
    setcountry(value){
        this.country = value
    }

    @action
    setVenueContactName(value){
        this.venueContactName = value
    }

    @action
    setDefaultValue(data){
        this.venueLegalEntityName = data.profileName;
        this.venueEmail = data.email;
        this.venuePhone = data.contactPhone;
        this.streetAddress = data.street;
        this.suburb = data.city;
        this.state = data.state;
        this.country = data.countryCode;
        this.postCode = data.postal;
        // this.manageContactName = data.manageContactName;
        // this.manageContactEmail = response.manageContactEmail;
        // this.manageContactPhone = response.manageContactPhone;
        // this.venueContactName = response.venueContactName;
    }


    @action
    getAgentVenueContact(id) {
        return agent.AgentVenueContact.get(id).then(action(response => {
            if(response){
                this.id = response.id
                this.venueLegalEntityName = response.venueLegalEntityName;
                this.venueEmail = response.venueEmail;
                this.venuePhone = response.venuePhone;
                this.streetAddress = response.streetAddress;
                this.suburb = response.suburb;
                this.postalOutgoing = response.postalOutgoing;
                this.state = response.state;
                this.country = response.country;
                this.postCode = response.postCode
                this.manageContactName = response.manageContactName;
                this.manageContactEmail = response.manageContactEmail;
                this.manageContactPhone = response.manageContactPhone;
                this.venueContactName = response.venueContactName;
                this.switchOn = response.switchOn !== undefined ? response.switchOn : false;
    
            }
            
            return response;
        }));
    }
    @action
    reset() {
        this.id = undefined
        this.venueContactName = ""
        this.venueLegalEntityName = ""
        this.venueEmail = ""
        this.venuePhone = ""
        this.streetAddress = ""
        this.suburb = ""
        this.postalOutgoing =""
        this.state = ""
        this.country = ""
        this.manageContactName = ""
        this.manageContactEmail = ""
        this.manageContactPhone = ""
        this.switchOn = false
    }
    @action
    createOrUpdate(agentVenueId) {
        var data = {
            venueLegalEntityName : this.venueLegalEntityName,
            venueEmail : this.venueEmail,
            venuePhone : this.venuePhone,
            streetAddress : this.streetAddress,
            suburb : this.suburb,
            postCode : this.postCode,
            state : this.state,
            country : this.country,
            manageContactName : this.manageContactName,
            manageContactEmail : this.manageContactEmail,
            manageContactPhone : this.manageContactPhone,
            venueContactName: this.venueContactName,
            switchOn : this.switchOn !== undefined ? this.switchOn : false,
            agentVenueId: agentVenueId
        }
        if(this.id){
            data.id = this.id
        }
        return agent.AgentVenueContact.create(data).then(response => {
            this.id = response.id
            return response
        });
    }
}

export default new AgentVenueContactStore();
